import React from "react";
import {
  FaCat, FaTag, FaCamera, FaImage, FaQuoteLeft, FaGlobe, FaSignature, FaLink,
  FaWandMagicSparkles, FaLock, FaCircleCheck, FaCalendar, FaCalendarCheck, FaCalendarDay,
  FaCakeCandles, FaHourglassHalf, FaPencil, FaBook, FaBookBookmark, FaBookOpenReader,
  FaNewspaper, FaShareNodes, FaFeather, FaEye, FaRocket, FaComment, FaComments, FaBullhorn,
  FaBug, FaReply, FaHandHoldingHeart, FaCommentDots, FaAward, FaHeart, FaHeartCirclePlus,
  FaThumbsUp, FaStarHalfStroke, FaTrophy, FaListUl, FaChartLine, FaLifeRing, FaBoxOpen,
  FaGraduationCap, FaBuilding, FaDownload, FaSeedling, FaShoePrints, FaFire, FaPen, FaStar,
  FaShieldHalved, FaMedal, FaCrown,
} from "react-icons/fa6";
import { GiButterfly, GiLaurelsTrophy, GiDjedPillar, GiSparkles, GiMegaphone } from "react-icons/gi";

// Maps the plain-string icon keys stored server-side (achievements.js /
// ranking.js) to an actual icon component. Keeping this mapping purely on
// the frontend means the backend never has to know about a specific icon
// library, and swapping icons never touches the DB.
export const ICON_MAP = {
  sparkles: FaCat,
  tag: FaTag,
  camera: FaCamera,
  image: FaImage,
  quote: FaQuoteLeft,
  globe: FaGlobe,
  signature: FaSignature,
  link: FaLink,
  butterfly: GiButterfly,
  wand: FaWandMagicSparkles,
  lock: FaLock,
  "check-circle": FaCircleCheck,
  calendar: FaCalendar,
  "calendar-check": FaCalendarCheck,
  "calendar-star": FaCalendarDay,
  cake: FaCakeCandles,
  hourglass: FaHourglassHalf,
  pencil: FaPencil,
  notebook: FaBook,
  books: FaBookBookmark,
  newspaper: FaNewspaper,
  share: FaShareNodes,
  feather: FaFeather,
  eye: FaEye,
  rocket: FaRocket,
  "message-plus": FaComment,
  messages: FaComments,
  megaphone: GiMegaphone,
  bullhorn: FaBullhorn,
  bug: FaBug,
  "trophy-star": GiLaurelsTrophy,
  reply: FaReply,
  "hand-heart": FaHandHoldingHeart,
  "chat-dots": FaCommentDots,
  column: GiDjedPillar,
  "check-badge": FaAward,
  heart: FaHeart,
  "heart-plus": FaHeartCirclePlus,
  sparkle: GiSparkles,
  "thumbs-up": FaThumbsUp,
  "star-half": FaStarHalfStroke,
  trophy: FaTrophy,
  "book-open": FaBookOpenReader,
  list: FaListUl,
  activity: FaChartLine,
  "life-buoy": FaLifeRing,
  package: FaBoxOpen,
  "graduation-cap": FaGraduationCap,
  building: FaBuilding,
  download: FaDownload,
  // ranking levels
  seedling: FaSeedling,
  footprints: FaShoePrints,
  flame: FaFire,
  pen: FaPen,
  star: FaStar,
  shield: FaShieldHalved,
  medal: FaMedal,
  crown: FaCrown,
};

export default function AchievementIcon({ icon, size = 16, className = "" }) {
  const Icon = ICON_MAP[icon] || FaStar;
  return <Icon size={size} className={className} />;
}
